/**
 * useStep4 — props-bundling hook for Step 4 (Carga Historial Laboral).
 *
 * This hook does NOT create new state or effects. It simply collects
 * existing App.jsx closures into named prop bundles so components
 * receive focused, stable prop objects instead of 70+ individual props.
 */
export default function useStep4({
  // Mode selector
  modoHerramienta, cargaHistorialModo, setCargaHistorialModo,
  simulationEnabled, rows, setRows, rawRows, setRawRows,
  selectedCaseId, setSelectedCaseId, simulationCases, loadSimulationCase,
  caseData, resetRemainingSession, setUltimoPeriodoDetectado,
  extractPdfHeaderCese, setFechaCeseCabeceraPdf,
  toFechaInputFromPeriodoKey, expediente, setExpediente,
  resetCaseSession, setFechaCeseSugerida,
  setActividadFuentes, titularCuilOrigen, setTitularCuilOrigen,
  processParserOutput, activeRules, normalizeReviewRows,
  setManualResumenTotalesDraft, setCalculoReady,
  setProgressLabel, progressLabel,
  manualRowsDraft, updateManualRow, addManualRow, manualRowsValid, loadManualRows,
  sanitizeExpedienteScenarioForPdfIngestion,
  // Review shell
  reviewTab, setReviewTab, reviewMode, setReviewMode,
  resumenHistorialLaboralRows,
  // Procesamiento info
  scoreCertezaInforme, shadowBilling, CORE_RULES_CONFIG,
  shadowTopConflicts, setSelectedConflictCuit, selectedConflictCuit,
  shadowResumenMeta, manualResumenTotalesDraft,
  updateManualResumenRow, addManualResumenRow,
  applyManualResumenTotales, conciliacionManualActa,
  periodosResumenControl, downloadProcessingLog, processingPayloadAt,
  // Edicion toolbar
  showManualRangePanel, setShowManualRangePanel,
  manualRangeDraft, setManualRangeDraft, applyManualRange,
  // Yearly table
  groupedByYearFiltered, expandedYears, setExpandedYears,
  updateRowField, removeRevisionRow,
  // Mutation audit (already a component)
  mutationsLog, mutationsIntegrityHash, mutationsQualityAudit,
  copyHashFeedback, setCopyHashFeedback,
  showMutationsAccordion, setShowMutationsAccordion,
  // Clinical
  minusMonthsIso, expedienteCalculo,
  prorrateoServiciosDraft, updateProrrateoServicio,
  addProrrateoServicio, applyProrrateoServicios,
  rowsVista, topeGlobalAudit, mirrorRows,
  // Footer
  goBack, caseValidation, warningsAcknowledged,
  setWarningsAcknowledged, onSolicitarGenerarCalculo,
  canGenerarCalculo, calculoLoading, COINS_POR_CALCULO,
  motivoBloqueoCalculo, calculoFetchError, setCalculoFetchError,
}) {
  return {
    modeSelectorProps: {
      modoHerramienta, cargaHistorialModo, setCargaHistorialModo,
      simulationEnabled, rows,
      selectedCaseId, setSelectedCaseId, simulationCases, loadSimulationCase,
      caseData, resetRemainingSession, setUltimoPeriodoDetectado,
      extractPdfHeaderCese, setFechaCeseCabeceraPdf,
      toFechaInputFromPeriodoKey, expediente, setExpediente,
      resetCaseSession, setFechaCeseSugerida,
      setActividadFuentes, titularCuilOrigen, setTitularCuilOrigen,
      processParserOutput, activeRules, normalizeReviewRows,
      setManualResumenTotalesDraft, setRows, setRawRows, setCalculoReady,
      setProgressLabel, progressLabel,
      manualRowsDraft, updateManualRow, addManualRow, manualRowsValid, loadManualRows,
      sanitizeExpedienteScenarioForPdfIngestion,
    },
    reviewShellProps: {
      cargaHistorialModo, setCargaHistorialModo,
      rows, setRows, rawRows, setRawRows, setCalculoReady,
      reviewTab, setReviewTab, reviewMode, setReviewMode,
      resumenHistorialLaboralRows, modoHerramienta,
    },
    procesamientoInfoProps: {
      reviewTab, scoreCertezaInforme, modoHerramienta,
      shadowBilling, CORE_RULES_CONFIG,
      shadowTopConflicts, setSelectedConflictCuit, setReviewTab,
      selectedConflictCuit,
      shadowResumenMeta, manualResumenTotalesDraft,
      updateManualResumenRow, addManualResumenRow,
      applyManualResumenTotales, conciliacionManualActa,
      periodosResumenControl, downloadProcessingLog, processingPayloadAt,
    },
    edicionToolbarProps: {
      reviewTab, rows, modoHerramienta,
      showManualRangePanel, setShowManualRangePanel,
      manualRangeDraft, setManualRangeDraft, applyManualRange,
    },
    yearlyTableProps: {
      reviewTab, groupedByYearFiltered, expandedYears,
      setExpandedYears, updateRowField, reviewMode, removeRevisionRow,
    },
    mutationAccordionProps: {
      reviewTab,
      mutationsLog, mutationsIntegrityHash, mutationsQualityAudit,
      copyHashFeedback, setCopyHashFeedback,
      showMutationsAccordion, setShowMutationsAccordion,
    },
    clinicalPanelsProps: {
      reviewTab, minusMonthsIso, expedienteCalculo,
      modoHerramienta,
      prorrateoServiciosDraft, updateProrrateoServicio,
      addProrrateoServicio, applyProrrateoServicios,
      activeRules, rowsVista, topeGlobalAudit,
      shadowBilling, scoreCertezaInforme,
      shadowTopConflicts, mirrorRows, expediente,
    },
    footerProps: {
      rows, goBack, caseValidation, warningsAcknowledged,
      setWarningsAcknowledged, onSolicitarGenerarCalculo,
      canGenerarCalculo, calculoLoading, COINS_POR_CALCULO,
      motivoBloqueoCalculo, calculoFetchError, setCalculoFetchError,
    },
  }
}
